import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=e7d1e280&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=e7d1e280&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports